import { css } from 'lit';

export default css`
  :host {
    display: block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--z-index-dialog, 2000);
  }

  .action-sheet {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    gap: 0;
    width: 350px;
    background: transparent;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--spacing-md, 16px) var(--spacing-lg, 24px);
		width: 100%;
		box-sizing: border-box;
    background: var(--color-gray-1, #F7F5F4);
    border-radius: 8px 8px 0 0;
  }

  .header > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-xxs, 4px);
    width: 302px;
  }

  .title {
    width: 100%;
    font-size: var(--font-size-s2, 16px);
    line-height: var(--line-height-s2, 24px);
    font-weight: var(--font-weight-semibold, 600);
    color: var(--color-dark-gray, #1C2321);
    text-align: center;
  }

  .message {
    width: 100%;
    font-size: var(--font-size-b3, 14px);
    line-height: var(--line-height-b3, 20px);
    font-weight: var(--font-weight-regular, 400);
    color: var(--color-gray-6, #7C7C7C);
    text-align: center;
  }

  .actions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    width: 100%;
  }

  .action {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .action button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: var(--spacing-sm, 16px) var(--spacing-md, 24px);
    width: 100%;
    height: 48px;
    background: var(--color-gray-1, #F7F5F4);
    border: none;
    font-size: var(--font-size-button-large, 16px);
    line-height: var(--line-height-button-large, 20px);
    font-weight: var(--font-weight-semibold, 600);
    cursor: pointer;
  }

  .action.first button {
    border-radius: 8px 8px 0 0;
  }

  .action.last button {
    border-radius: 0 0 8px 8px;
  }

  .divider {
    width: 100%;
    height: 1.5px;
    background: var(--color-gray-2, #E7E5E4);
  }

  .footer-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 20px;
    width: 100%;
    height: 48px;
    background: var(--color-primary-dark, #001D68);
    border-radius: var(--radius-md, 12px);
    border: none;
    font-size: var(--font-size-button-large, 16px);
    line-height: var(--line-height-button-large, 20px);
    font-weight: var(--font-weight-semibold, 600);
    color: var(--color-white, #FFFFFF);
    cursor: pointer;
		margin-top: 16px;
  }
`;
